<script lang="ts">
	import { DashControlWidget } from '@Shelly/shelly-design-system/index';
	import ControlGroupDirection from 'src/components/Controls/Group/ControlGroupDirection.svelte';
	import ControlGroupOnOff from 'src/components/Controls/Group/ControlGroupOnOff.svelte';
	import ControlGroupThermostat from 'src/components/Controls/Group/ControlGroupThermostat.svelte';
	import { checkForMissingDevice } from 'src/components/Lists/list-helpers';
	import { createMemberStatusSnapshot } from 'src/stores/device-runtime/status-selectors';
	import { devices } from 'src/stores/lists/devices';
	import { groups } from 'src/stores/lists/groups';
	import { edit } from 'src/stores/ui/edit_lists';
	import { sidePanelStateCombined } from 'src/stores/ui/sidepanel-public';
	import { getGroupDeviceState } from '../../dash-lights-helpers';
	import { load_image_from, real_id } from 'src/helpers/interface_helpers';
	import { getOfflineDeviceCount } from 'src/stores/device-runtime/states';
	import { format } from 'svelte-i18n';
	import type { DashDeviceWidgetPropsTypes } from '@Shelly/shelly-design-system';

	export let groupWidget;

	let additionalText: DashDeviceWidgetPropsTypes['additionalText'] = {
		value: '',
	};

	$: group = $groups[groupWidget?.id];

	$: memberStatusStore = createMemberStatusSnapshot(group?.devices ?? []);
	$: memberStatus = $memberStatusStore;

	$: hasMissingDevice = !!checkForMissingDevice(group?.devices)?.length;

	$: groupDeviceStatus = group?.devices
		.filter((id) => typeof $devices[id] !== 'undefined')
		.map((id) => {
			const state = getGroupDeviceState(group.type, $devices[id], memberStatus[real_id(id)]);
			return state;
		});

	$: devicesOn = groupDeviceStatus?.filter((status) => status)?.length;

	$: devicesOff = groupDeviceStatus?.filter((status) => status === false)?.length;

	$: offlineCountStore = getOfflineDeviceCount(group?.devices);
	$: offlineDevices = $offlineCountStore;

	$: avatar = !group
		? { icon: 'fa-light fa-triangle-exclamation text-color-warning' }
		: {
				backgroundColor: group?.backgroundColor || group?._meta?.backgroundColor,
				image: group?.image ? load_image_from(group?.image) : '',
			};

	$: additionalText = !group
		? {
				value: $format('label_missing_group', {
					default: 'Missing Group',
				}),
				type: 'warning',
			}
		: {
				value: hasMissingDevice
					? $format('label_missing_device', {
							default: 'Missing Device',
						})
					: `${devicesOn} on, ${devicesOff} off, ${offlineDevices} offline`,
				icon: hasMissingDevice ? 'fa-light fa-triangle-exclamation' : '',
				type: hasMissingDevice ? 'warning' : 'muted',
			};
</script>

<DashControlWidget
	aria-label="Dash Control Widget"
	class="cursor-pointer"
	value={!group ? groupWidget?.id : group?.name}
	{avatar}
	{additionalText}
	hideSlotRight={!group || $edit}
	on:click
	selected={groupWidget?.id === $sidePanelStateCombined?.id}
>
	<svelte:fragment slot="right">
		{#if group?.type === 'roller'}
			<ControlGroupDirection {group} variant="dashControlWidget" />
		{:else if group?.type === 'thermostat'}
			<ControlGroupThermostat {group} variant="dashControlWidget" />
		{:else}
			<ControlGroupOnOff {group} variant="dashControlWidget" />
		{/if}
	</svelte:fragment>
</DashControlWidget>
